export default [{
  path: '/branch',
  name: 'branch',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/branch/index')
}]
